export const BUTTON_STYLE_PRIMARY = 'primary'
export const BUTTON_STYLE_SECONDARY = 'secondary'
export const BUTTON_STYLE_SECONDARY_WHITE_BACKGROUND =
  'secondary-white-background'
export const BUTTON_STYLE_DANGER = 'danger'
export const BUTTON_STYLE_DEFAULT = 'default'
export const BUTTON_STYLE_DEFAULT_PRIMARY = 'default-primary'
export const BUTTON_STYLE_BLUE = 'blue'
export const BUTTON_STYLE_PAUTA = 'pauta'
export const BUTTON_STYLE_HEADER_PRIMARY = 'header-primary'
export const BUTTON_STYLE_HEADER_SECONDARY = 'header-secondary'
export const BUTTON_STYLE_HEADER_USER_PRIMARY = 'header-user-primary'
export const BUTTON_STYLE_HEADER_USER_SECONDARY = 'header-user-secondary'
export const BUTTON_STYLE_HEADER_USER_BOLD = 'header-user-bold'

export const ButtonThemes = [
  BUTTON_STYLE_PRIMARY,
  BUTTON_STYLE_SECONDARY,
  BUTTON_STYLE_SECONDARY_WHITE_BACKGROUND,
  BUTTON_STYLE_DANGER,
  BUTTON_STYLE_DEFAULT,
  BUTTON_STYLE_DEFAULT_PRIMARY,
  BUTTON_STYLE_BLUE,
  BUTTON_STYLE_PAUTA,
  BUTTON_STYLE_HEADER_PRIMARY,
  BUTTON_STYLE_HEADER_SECONDARY,
  BUTTON_STYLE_HEADER_USER_PRIMARY,
  BUTTON_STYLE_HEADER_USER_SECONDARY,
  BUTTON_STYLE_HEADER_USER_BOLD
]

export type ButtonThemesType = typeof ButtonThemes[number]
